export enum B2CSubscriptionState {
  Active = 1,
  Closed = 2,
  Disabled = 3,
  Unmapped = 4,
}

export enum B2CSubscriptionContactState {
  Enabled = 1,
  Disabled = 2,
}

export enum B2CSubscriptionContactAction {
  Mapping = 1,
  Unmapping = 2,
}

export enum B2CSubscriptionImportAction {
  Activation = 1,
  Termination = 2,
}

export enum B2CSubscriptionImportState {
  Unmapped = 1,
  MappedBySystem = 2,
  MappedByUser = 3,
  Ignored = 4,
  PartiallyMapped = 5,
}

export function B2CSubscriptionStateToString(value: B2CSubscriptionState): string {
  switch (value) {
    case B2CSubscriptionState.Active:
      return 'CONST.B2C_STATE.ACTIVE'; // TODO-B2C: translations!

    case B2CSubscriptionState.Closed:
      return 'CONST.B2C_STATE.CLOSED';

    case B2CSubscriptionState.Disabled:
      return 'CONST.B2C_STATE.DISABLED';

    case B2CSubscriptionState.Unmapped:
      return 'CONST.B2C_STATE.UNMAPPED';

    default:
      throw new Error(`Invalid enum value: ${value}`);
  }
}

export function B2CSubscriptionContactStateToString(value: B2CSubscriptionContactState): string {
  switch (value) {
    case B2CSubscriptionContactState.Enabled:
      return 'CONST.B2C_CONTACT_STATE.ENABLED'; // TODO-B2C: translations!

    case B2CSubscriptionContactState.Disabled:
      return 'CONST.B2C_CONTACT_STATE.DISABLED';

    default:
      throw new Error(`Invalid enum value: ${value}`);
  }
}

export function B2CSubscriptionContactActionToString(value: B2CSubscriptionContactAction): string {
  switch (value) {
    case B2CSubscriptionContactAction.Mapping:
      return 'CONST.B2C_CONTACT_ACTION.MAPPING'; // TODO-B2C: translations!

    case B2CSubscriptionContactAction.Unmapping:
      return 'CONST.B2C_CONTACT_ACTION.UNMAPPING';

    default:
      throw new Error(`Invalid enum value: ${value}`);
  }
}

export function B2CSubscriptionImportActionToString(value: B2CSubscriptionImportAction): string {
  switch (value) {
    case B2CSubscriptionImportAction.Activation:
      return 'CONST.B2C_IMPORT_ACTION.ACTIVATION'; // TODO-B2C: translations!

    case B2CSubscriptionImportAction.Termination:
      return 'CONST.B2C_IMPORT_ACTION.TERMINATION';

    default:
      throw new Error(`Invalid enum value: ${value}`);
  }
}

export function B2CSubscriptionImportStateToString(value: B2CSubscriptionImportState): string {
  switch (value) {
    case B2CSubscriptionImportState.Unmapped:
      return 'CONST.B2C_IMPORT_STATE.UNMAPPED'; // TODO-B2C: translations!

    case B2CSubscriptionImportState.MappedBySystem:
      return 'CONST.B2C_IMPORT_STATE.BYSYSTEM';

    case B2CSubscriptionImportState.MappedByUser:
      return 'CONST.B2C_IMPORT_STATE.BYUSER';

    case B2CSubscriptionImportState.Ignored:
      return 'CONST.B2C_IMPORT_STATE.IGNORED';

    case B2CSubscriptionImportState.PartiallyMapped:
      return 'CONST.B2C_IMPORT_STATE.PARTIALLY';

    default:
      throw new Error(`Invalid enum value: ${value}`);
  }
}
